import React from 'react'

const Star2 = ({ color, size }) => {
  return (
    <svg
      width={size || '14'}
      height={size || '14'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill={color || 'white'}
          d="M7.6,1.8c0.2-0.6,0.5-0.6,0.7,0l1.1,3.4c0.2,0.6,0.9,1.1,1.5,1.1h3.6c0.6,0,0.7,0.3,0.2,0.7l-2.9,2.1
		c-0.5,0.4-0.8,1.2-0.6,1.8l1.1,3.4c0.2,0.6-0.1,0.8-0.6,0.4l-2.9-2.1c-0.5-0.4-1.3-0.4-1.9,0l-2.9,2.1c-0.5,0.4-0.8,0.2-0.6-0.4
		l1.1-3.4c0.2-0.6-0.1-1.4-0.6-1.8L1.2,6.9C0.7,6.6,0.8,6.3,1.4,6.3H5c0.6,0,1.3-0.5,1.5-1.1L7.6,1.8z"
        />
      </g>
    </svg>
  )
}

export default Star2
